var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTextBox24Line = function SvgIconTextBox24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 4.65H7.3c-1.46 0-2.65 1.19-2.65 2.65v9.4c0 1.46 1.19 2.65 2.65 2.65h9.4c1.46 0 2.65-1.19 2.65-2.65V7.3c0-1.46-1.19-2.65-2.65-2.65Zm.95 12.05a.95.95 0 0 1-.95.95H7.3a.95.95 0 0 1-.95-.95V7.3a.95.95 0 0 1 .95-.95h9.4a.95.95 0 0 1 .95.95v9.4Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.76h3.1V16h1.8V9.76H16v-1.8H8v1.8Z",
    fill: "current"
  })));
};
export default SvgIconTextBox24Line;